import { useEffect } from 'react';

/**
 *
 * @param rowData.rowData
 * @param {Array} rowData - The data rows to process.
 * @param {number} currentPage - The current page number.
 * @param {number} pageSize - The number of items per page.
 * @param {Array} currentPlayerIds - The current player IDs to compare against.
 * @param {Function} setCurrentPlayerIds - Function to update the current player IDs.
 * @param rowData.currentPage
 * @param rowData.pageSize
 * @param rowData.currentPlayerIds
 * @param rowData.setCurrentPlayerIds
 * @description Custom hook to fetch and update current player pulse IDs.
 * It fetches player pulse IDs for the players in the current page and updates the state if the fetched IDs differ from the current ones.
 * @returns No return value, but updates the state with current player IDs.
 */
export const useCurrentPlayerPulseIds = ({
    rowData,
    currentPage,
    pageSize,
    currentPlayerIds,
    setCurrentPlayerIds
}) => {
    useEffect(() => {
        if (!rowData || rowData.length === 0) {
            return;
        }

        let isCancelled = false;

        const startIndex = pageSize * (currentPage - 1);
        const pageRows = rowData.slice(startIndex, startIndex + pageSize);

        const fetchIds = async () => {
            try {
                const promises = pageRows.map((row) =>
                    PULSE.app.common.pulseId.getPlayerPulseId(
                        row.player.playerId
                    )
                );

                const result = await Promise.all(promises);

                if (!isCancelled && !PULSE.app.common.arrayHelper.arraysEqual(result, currentPlayerIds)) {
                    setCurrentPlayerIds(result);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchIds();

        return () => {
            isCancelled = true;
        };
    }, [rowData, currentPage, pageSize]);

    return currentPlayerIds;
};
